import React from "react";
import ReactTooltip from "react-tooltip";

export const TcdHeaderFormatter = ({ id, text, tooltip }) => {
    return (
        <>
            <span
                data-tip
                data-for={id}
                style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
            >
                {text}
            </span>

            <ReactTooltip
                id={id}
                place="top"
                effect="solid"
                backgroundColor="#333"
            >
                <span>{tooltip}</span>
            </ReactTooltip>
        </>
    );
};